import { Save } from 'lucide-react';
import { colors } from '../../styles/colors';
import { DatePicker } from '../ui/DatePicker';

/**
 * PaymentForm - Formulaire d'ajout de paiement
 *
 * @param {Object} props
 * @param {Object} props.formData - Données du formulaire
 * @param {Function} props.onFormChange - Handler changement
 * @param {Function} props.onSubmit - Handler soumission
 * @param {boolean} props.saving - État de sauvegarde
 */
export default function PaymentForm({ formData, onFormChange, onSubmit, saving }) {
  const labelStyle = {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: '600',
    fontSize: '0.875rem',
    color: colors.primary.gray
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem',
    border: `2px solid ${colors.secondary.lightTeal}`,
    borderRadius: '0.5rem',
    fontSize: '1rem',
    boxSizing: 'border-box'
  };

  return (
    <>
      <h3 style={{
        fontSize: '1.125rem',
        fontWeight: '600',
        color: colors.primary.gray,
        marginBottom: '1rem'
      }}>
        Ajouter un paiement
      </h3>

      <div style={{
        padding: '1.5rem',
        backgroundColor: '#f9fafb',
        borderRadius: '0.5rem',
        border: `1px solid ${colors.secondary.lightGray}`
      }}>
        {/* Ligne Date + Montant */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
          <div>
            <label style={labelStyle}>Date</label>
            <DatePicker
              value={formData.date}
              max={new Date().toISOString().split('T')[0]}
              onChange={(v) => onFormChange('date', v)}
              style={inputStyle}
            />
          </div>

          <div>
            <label style={labelStyle}>
              Montant (€) <span style={{ color: '#dc2626' }}>*</span>
            </label>
            <input
              type="number"
              step="0.01"
              value={formData.montant}
              onChange={(e) => onFormChange('montant', e.target.value)}
              placeholder="0.00"
              style={inputStyle}
            />
          </div>
        </div>

        {/* Référence bancaire */}
        <div style={{ marginBottom: '1rem' }}>
          <label style={labelStyle}>Référence bancaire</label>
          <input
            type="text"
            value={formData.referenceBancaire}
            onChange={(e) => onFormChange('referenceBancaire', e.target.value)}
            placeholder="VIR123456"
            style={inputStyle}
          />
        </div>

        {/* Notes */}
        <div style={{ marginBottom: '1rem' }}>
          <label style={labelStyle}>Notes</label>
          <textarea
            value={formData.notes}
            onChange={(e) => onFormChange('notes', e.target.value)}
            placeholder="Commentaire optionnel"
            rows="2"
            style={{
              ...inputStyle,
              fontFamily: '"Noto Sans", sans-serif',
              resize: 'vertical'
            }}
          />
        </div>

        {/* Bouton */}
        <button
          onClick={onSubmit}
          disabled={saving}
          style={{
            width: '100%',
            padding: '0.75rem 1.5rem',
            backgroundColor: colors.primary.teal,
            color: colors.text.white,
            border: 'none',
            borderRadius: '0.5rem',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: saving ? 'not-allowed' : 'pointer',
            opacity: saving ? 0.5 : 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem'
          }}
        >
          <Save size={18} />
          {saving ? 'Enregistrement...' : 'Ajouter le paiement'}
        </button>
      </div>
    </>
  );
}
